export default {
  page_title: '意見及查詢',
  email: '閣下的電郵地址',
  comment: '閣下的意見及查詢',
  success: '閣下的意見已成功提交。謝謝。',
  feedback: [
    'HKLII提供免費的法律資訊，並歡迎閣下就如何改善服務提出反饋，以及對HKLII服務作出鼓勵。雖然HKLII的服務是免費提供，但我們依然會在資源允許的情況下，盡力保持最專業服務質素。',
    '<b>請確保填寫有效的電郵地址，以便我們向閣下發送回覆。</b> 如沒有填寫有效的電郵地址，我們將無法回覆。'
  ],
  disclaimers_tag: '免責聲明',
  disclaimers: [
    '作為計算機科學家，我們旨在將法律資訊電腦化，並透過HKLII 的服務，令大眾能獲取免費法律資訊。我們不會也無法提供任何法律建議或回答有關法律的問題。',
    '閣下可以使用我們的搜尋引擎來搜尋感興趣的主題的關鍵字。如閣下需要更多有關搜尋引擎使用上的協助，請隨時於我們的意見頁面與我們的團隊聯繫。'
  ],
  close: 'HKLII 團隊<br/>香港資訊科技及法律研究中心<br/>香港大學',
  ratetitle: '評價重製的 HKLII',
  rateintro: '在過去一年 HKLII 團隊根據用家的反饋改寫了本網站的功能與介面。現希望閣下能撥冗填寫問卷，使 HKLII 更為實用。',
  rate_nav: '導航清晰度',
  rate_interface: '介面效率',
  rate_search: '搜尋準確度',
  rate_data: '內容齊備',
  comments: '意見',
  comment_hint: '若你希望收到 HKLII 團隊的回覆或跟進調查，請將你的電郵地址一併填入意見格內。謝謝。',
}